import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, Events } from 'ionic-angular';
import { GlobalVars } from '../../providers/global-vars';
import { ApiCaller } from '../../providers/api-caller';
import {TranslateService} from 'ng2-translate/ng2-translate';

import { NewGuestPage } from '../../pages/new-guest/new-guest';

/*
  Generated class for the GateGuests page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-gate-guests',
  templateUrl: 'gate-guests.html'
})
export class GateGuestsPage {
    
    public theDevice: any = {};
    public guests: any = [];

  constructor(public navCtrl: NavController, public navParams: NavParams,public events: Events, public apiCaller : ApiCaller, 
              public globalVars : GlobalVars, public alertCtrl: AlertController, private translate: TranslateService) {
      
      this.theDevice = navParams.get('theDevice');
      console.log('Doing device: '+JSON.stringify(this.theDevice));
      
      events.subscribe('refreshGuests', () => {
         //   console.log('ViewShares received event: refreshGuests');
           this.getGuests();
        });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GateGuestsPage');
      this.getGuests();
  }

    addGuest(){
        this.navCtrl.push(NewGuestPage,{theDevice:this.theDevice });
    }
    
    getGuests(){ 
        console.log('getGuests');
        var requestApp = {};
        (requestApp as any).requestType = 'guestsByDevice';
      
        (requestApp as any).request = {};
        (requestApp as any).request.userId = this.globalVars.userSettings.user_id;
        (requestApp as any).request.activationCode = this.globalVars.generalVars.activationCode;
        (requestApp as any).request.deviceUserId = this.theDevice.device_user_id;
        (requestApp as any).request.language = this.globalVars.userLanguage;
        
        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, true).then(data => {
            if (data && (data as any).result == 200){
                this.guests = (data as any).data.shares;
            }
        });
    }
    doDelete(whichOne){ 
        console.log("Deleteing guest: "+JSON.stringify(whichOne))
       let confirm = this.alertCtrl.create({
      title: this.translate.instant("Are you sure?"),
      message: this.translate.instant('This will permanently delete this guest.'),
      buttons: [
        {
          text: this.globalVars.msgNo,
          handler: () => {
            return;
          }
        },
        {
          text: this.globalVars.msgYes,
          handler: () => {
            console.log('doDelete');
            var requestApp = {};
            (requestApp as any).requestType = 'deleteGuest';

            (requestApp as any).request = {};
            (requestApp as any).request.userId = this.globalVars.userSettings.user_id;
            (requestApp as any).request.activationCode = this.globalVars.generalVars.activationCode;
            (requestApp as any).request.deviceUserId = whichOne.device_user_id;
            (requestApp as any).request.mainDeviceUserId = this.theDevice.device_user_id;
              
            this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, true).then(data => {
                if (data && (data as any).result == 200){
                    console.log("Got back: "+JSON.stringify(data));
                    this.guests = (data as any).data.shares;
                    //this.getGuests();
                }
            });
                              return;
              }
            }
          ]
        });
        confirm.present();
    }


}



// WEBPACK FOOTER //
// ./src/pages/gate-guests/gate-guests.ts